import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class ConstantesService {
  // Headers
  public httpOptions = {
  };
  respuestaActivosCacheados: any; // Se guardara el formato de respuesta habitual...data{succes:...}

  constructor() {
    this.refrescarHeaders();
  }

  refrescarHeaders(){
    // Se tiene que llamar a este método cuando se haya obtenido el token
    this.httpOptions = {
      headers: new HttpHeaders({
      'Content-Type': 'application/json' ,
      'Authorization': 'Bearer ' + sessionStorage.getItem('tokenBim')
      })
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/core/constantes/constantes.service.ts